<template>
  <div class="record-card-renderer">
    <component
      :is="cardComponent"
      v-for="(item, index) in items"
      :key="index"
      :item="item"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import PropertyCard from '@/bundles/AiAgent/components/cards/PropertyCard.vue';
import PipelineCard from '@/bundles/AiAgent/components/cards/PipelineCard.vue';
import AvailabilityCard from '@/bundles/AiAgent/components/cards/AvailabilityCard.vue';
import DealCard from '@/bundles/AiAgent/components/cards/DealCard.vue';

export default Vue.extend({
  name: 'RecordCardRenderer',

  components: {
    PropertyCard,
    PipelineCard,
    AvailabilityCard,
    DealCard,
  },

  props: {
    recordType: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },

  computed: {
    cardComponent (): string {
      const componentMap: Record<string, string> = {
        property: 'PropertyCard',
        pipeline: 'PipelineCard',
        availability: 'AvailabilityCard',
        deal: 'DealCard',
        // TODO: add other record types
      };
      return componentMap[this.recordType];
    },
  },
});
</script>

<style lang="scss" scoped>
.record-card-renderer {
  display: flex;
  flex-direction: column;
}
</style>
